import React, { useState } from 'react';
import './Login.css';
import { Link, useNavigate } from 'react-router-dom';
import StorefrontIcon from '@mui/icons-material/Storefront';
import { auth } from './Firebase';
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword
} from 'firebase/auth';

function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signIn = (e) => {
        e.preventDefault();

        if (!email || !password) {
            alert("Email and password are required.");
            return;
        }

        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                console.log("Signed in:", userCredential.user);
                navigate('/');
            })
            .catch((error) => {
                console.error("Sign in error:", error);
                alert(error.message);
            });
    };

    const register = (e) => {
        e.preventDefault();

        if (!email || !password) {
            alert("Email and password are required.");
            return;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            alert("Please enter a valid email address.");
            return;
        }

        if (password.length < 6) {
            alert("Password must be at least 6 characters.");
            return;
        }

        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                console.log("Registered:", userCredential.user);
                navigate('/');
            })
            .catch((error) => {
                console.error("Registration error:", error);
                alert(error.message);
            });
    };

    return (
        <div className='login'>
            <Link to='/' style={{ textDecoration: 'none' }}>
                <div className='login__logo'>
                    <StorefrontIcon className='login__logoImage' fontSize='large' />
                    <h2 className='login__logoTitle'>eSHOP</h2>
                </div>
            </Link>

            <div className='login__container'>
                <h1>Sign-in</h1>

                <form>
                    <h5>E-mail</h5>
                    <input
                        type='text'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <h5>Password</h5>
                    <input
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                        type='submit'
                        className='login__signInButton'
                        onClick={signIn}
                    >
                        Sign In
                    </button>
                </form>

                <p>
                    By signing-in you agree to the eShop Website Conditions of Use & Sale. Please
                    see our Privacy Notice, our Cookies Notice and our Interest-Based Ads Notice.
                </p>

                <button className='login__registerButton' onClick={register}>
                    Create your eShop Account
                </button>
            </div>
        </div>
    );
}

export default Login;
